// src/styles/SettingsStyles.js
import styled from 'styled-components';
import { Card } from '../main/CommonStyles';

export const SettingsSection = styled(Card)`
    margin-bottom: ${({ theme }) => theme.spacing.lg};
    // ... etc.
`;